export interface Modifiable {
  modified: Date
}
